// Core
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
`;

export const Separator = styled.div`
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.borderColor};
  margin-bottom: 24px;
`;

export const ListContainer = styled.div`
  padding-right: 24px;
`;
